// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1yX6-","header":"PatientQuestionnaire_header__3MM5a","info":"PatientQuestionnaire_info__1APpD"};